const n = {
  name: "TriangleDown",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12.0001 16.6008L18.0807 9H5.91943L12.0001 16.6008Z" fill="currentColor"/>
</svg>
  `
};
export {
  n as TriangleDown
};
